import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FaCloudUploadAlt, FaTimes } from "react-icons/fa";
import ClientDocumentsModal from "../reports/commissions/ClientDocumentsModal";
import UploadProviderContract from "../Applications/UploadProviderContract";
import { mapProviderContractsToDocuments } from "./providerContractDocuments";

const UPLOAD_BTN_CLASS =
  "inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-semibold text-slate-600 transition hover:border-[#007BFF]/30 hover:text-[#007BFF]";

function ProviderDocumentsModal({
  open,
  providerId,
  providerName,
  documents = [],
  onClose,
  onDocumentsUpdated,
}) {
  const [showUploadModal, setShowUploadModal] = useState(false);

  useEffect(() => {
    if (!open) {
      setShowUploadModal(false);
    }
  }, [open]);

  const handleContractsChange = (contracts) => {
    const nextDocuments = mapProviderContractsToDocuments(contracts);
    onDocumentsUpdated?.(providerId, nextDocuments);
  };

  const headerActions = providerId ? (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        setShowUploadModal(true);
      }}
      className={UPLOAD_BTN_CLASS}
      style={{ boxShadow: "none" }}
    >
      <FaCloudUploadAlt size={10} />
      Upload Document
    </button>
  ) : null;

  return (
    <>
      <ClientDocumentsModal
        open={open}
        clientName={providerName || "Provider"}
        documents={documents}
        onClose={onClose}
        title="Provider contracts"
        sidebarLabel="Contracts"
        contractsOnly
        headerActions={headerActions}
      />

      <Modal
        show={open && showUploadModal}
        onHide={() => setShowUploadModal(false)}
        centered
        size="lg"
        backdropClassName="cms-app-modal-backdrop cms-app-modal-backdrop--stack-top"
        backdrop="static"
        dialogClassName="cms-provider-contract-modal-dialog"
        contentClassName="cms-provider-contract-modal-content tailwind-container"
        className="cms-provider-contract-modal cms-provider-upload-modal-stack"
      >
        <Modal.Header
          closeButton={false}
          className="cms-provider-contract-modal-header cms-provider-contract-modal-header--with-close"
        >
          <Modal.Title className="cms-provider-contract-modal-title">
            Upload Provider Contract
          </Modal.Title>
          <button
            type="button"
            className="cms-provider-contract-modal-dismiss-btn"
            onClick={() => setShowUploadModal(false)}
            aria-label="Close upload modal"
          >
            <FaTimes size={12} />
          </button>
        </Modal.Header>
        <Modal.Body className="cms-provider-contract-modal-body">
          {providerId ? (
            <UploadProviderContract
              provider_id={providerId}
              embedded
              uploadFormOnly
              skipContractFetch
              onContractsChange={(contracts) => {
                handleContractsChange(contracts);
                setShowUploadModal(false);
              }}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer className="cms-provider-contract-modal-footer">
          <button
            type="button"
            className="cms-provider-contract-modal-close-btn"
            onClick={() => setShowUploadModal(false)}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProviderDocumentsModal;
